import { Grid } from '@backstage/ui';
import { AboutContent, AboutField } from '@backstage/plugin-catalog';
import { useEntity, EntityInfoCard } from '@backstage/plugin-catalog-react';
import {
  getAwsAccountId,
  getAwsAccountEnvironment,
  isAwsAccountEntity,
} from './awsAccount';

/**
 * Renders the AWS-account-specific fields (account id, environment) as
 * {@link AboutField}s below Backstage's standard AboutContent, mirroring the
 * LocalDevAboutCard pattern. Only the extra fields are account-specific; the
 * standard fields (owner, type, dependsOn, …) come from AboutContent.
 */
function AwsAccountFields() {
  const { entity } = useEntity();
  if (!isAwsAccountEntity(entity)) return null;

  const accountId = getAwsAccountId(entity);
  const environment = getAwsAccountEnvironment(entity);

  // Same responsive column config as AboutContent (plugin-catalog).
  const columns = { initial: '1', sm: '2', lg: '3' } as const;

  return (
    <Grid.Root columns={columns} gap="3">
      <AboutField label="AWS Account ID" value={accountId ?? 'unknown'} />
      <AboutField label="Environment" value={environment ?? 'unknown'} />
    </Grid.Root>
  );
}

/**
 * Drop-in replacement for `EntityAboutCard` on the AWS-account Resource page
 * that adds the account id and environment fields. Reuses Backstage's
 * `AboutContent` for the standard fields.
 */
export function AwsAccountAboutCard() {
  const { entity } = useEntity();

  return (
    <EntityInfoCard title="About">
      <AboutContent entity={entity} />
      <AwsAccountFields />
    </EntityInfoCard>
  );
}
